import React, { useEffect, useState } from "react";
import { fetchHijriDate } from "../../services/hijriService";

const Header = ({ timingColor, textColor, backgroundColor, currentTime, prayerData }) => {
  const [hijriDate, setHijriDate] = useState("...");

  // ✅ Fix: Extract the date string here so it can be statically checked
  // This ensures the effect only re-runs when the *day* changes, not every second.
  const currentDateStr = currentTime ? currentTime.format("DD-MM-YYYY") : null;

  useEffect(() => {
    if (!currentDateStr) return;

    const getHijri = async () => {
      try {
        const lat = prayerData?.startTimes?.latitude;
        const long = prayerData?.startTimes?.longitude;
        
        // Use the extracted variable
        const rawHijri = await fetchHijriDate(currentDateStr, lat, long);
        
        // Reformat logic (Day Month Year -> Month Day, Year)
        const parts = rawHijri.split(" ");
        if (parts.length === 3) {
            setHijriDate(`${parts[1]} ${parts[0]}, ${parts[2]}`);
        } else {
            setHijriDate(rawHijri);
        }
      } catch (e) {
         // console.warn(e);
      }
    };
    getHijri();
  }, [currentDateStr, prayerData]); // ✅ Dependency is now a simple variable

  if (!currentTime) return null;

  return (
    <div 
      className="w-full flex justify-between items-center h-full px-[1svh]"
      style={{ 
        backgroundColor: backgroundColor, 
        color: textColor,
        borderRadius: "1svh" 
      }} 
    >
      {/* Left: Dates */}
      <div className="flex flex-col justify-center items-center text-[3.3svh] uppercase" style={{ color: "inherit" }}>
        
        {/* Gregorian: Day ShortMonth Date */}
        <div className="font-medium leading-tight">
          {currentTime.format("dddd MMM DD")}
        </div>
        
        {/* Hijri: Centered below */}
        <div className="font-medium text-center leading-tight">
          {hijriDate}
        </div>
      </div>

      {/* Right: Time */}
      <div className="flex align-center" style={{ color: timingColor }}>
        <div className="text-[10.3svh] leading-none font-[Digital-7]">
          {currentTime.format("h:mm")}
        </div>
        <div className="flex flex-col justify-center ml-[1svh] text-[3.6svh] leading-[1.1] font-semibold">
          <div>{currentTime.format("ss")}</div>
          <div className="uppercase">{currentTime.format("A")}</div>
        </div>
      </div>
    </div>
  );
};

export default Header;